import { addDisposer } from 'mobx-state-tree';
import { reaction } from 'mobx';
import type { IJobApplicationStore } from '../JobApplicationStore';

const markApplicationRead = (jobApplicationStore: IJobApplicationStore) => {
  const onSelectedApplicationChange = reaction(
    () => jobApplicationStore.shownDetailsJobApplication,
    (jobApplication) => {
      if (jobApplication) {
        return jobApplication.markRead();
      }
    },
  );
  addDisposer(jobApplicationStore, onSelectedApplicationChange);
};

export default markApplicationRead;
